import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import {
  components as componentsBallBareConcreteFloor,
  extraContent as extraContentBallBareConcreteFloor,
} from "./components/ball-bare-concrete-floor";
import {
  components as componentsBallDryFloatingFloor,
  extraContent as extraContentBallDryFloatingFloor,
} from "./components/ball-dry-floating-floor";
import {
  components as componentsJumpingBareConcreteFloor,
  extraContent as extraContentJumpingBareConcreteFloor,
} from "./components/jumping-bare-concrete-floor";
import {
  components as componentsJumpingDryFloatingFloor,
  extraContent as extraContentJumpingDryFloatingFloor,
} from "./components/jumping-dry-floating-floor";
import {
  components as componentsTappingMachineBareConcreteFloor,
  extraContent as extraContentTappingMachineBareConcreteFloor,
} from "./components/tapping-machine-bare-concrete-floor";
import {
  components as componentsTappingMachineDryFloatingFloor,
  extraContent as extraContentTappingMachineDryFloatingFloor,
} from "./components/tapping-machine-dry-floating-floor";

const principle: Slide = {
  description:
    "The upper room is the source room. You can choose from three different sources, such as tapping machine, ball and jumping human. The room below is the receiving room with a built-in microphone. The surface in the middle is the concrete floor. You can choose whether to add a dry floating floor to it.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [{ name: "Tapping machine" }, { name: "Ball" }, { name: "Jumping" }],
          options: {},
        },
        {
          type: "button",
          items: [{ name: "Bare concrete floor" }, { name: "Dry floating floor" }],
          options: {},
        },
      ],
      extraContent: [
        [extraContentTappingMachineBareConcreteFloor, extraContentTappingMachineDryFloatingFloor],
        [extraContentBallBareConcreteFloor, extraContentBallDryFloatingFloor],
        [extraContentJumpingBareConcreteFloor, extraContentJumpingDryFloatingFloor],
      ],
      components: [
        [componentsTappingMachineBareConcreteFloor, componentsTappingMachineDryFloatingFloor],
        [componentsBallBareConcreteFloor, componentsBallDryFloatingFloor],
        [componentsJumpingBareConcreteFloor, componentsJumpingDryFloatingFloor],
      ],
    },
  },
};

export default principle;
